import HelpCenterPage from './pages/HelpCenterPage.vue';
import HowItWorksPage from './pages/HowItWorksPage.vue';
import PrivacyPage from './pages/PrivacyPage.vue';
import CookiesPage from './pages/CookiesPage.vue';
import TermsPage from './pages/TermsPage.vue';
import AccessibilityPage from './pages/AccessibilityPage.vue';

export default [
  {
    path: '/help',
    name: 'help',
    component: HelpCenterPage,
    meta: { title: 'Besoin d\'aide ?' }
  },
  {
    path: '/how-it-works',
    name: 'how-it-works',
    component: HowItWorksPage,
    meta: { title: 'Fonctionnement' }
  },
  {
    path: '/privacy-statement',
    name: 'privacy',
    component: PrivacyPage,
    meta: { title: 'Confidentialité' }
  },
  {
    path: '/cookie-statement',
    name: 'cookies',
    component: CookiesPage,
    meta: { title: 'Cookies' }
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsPage,
    meta: { title: 'Conditions d\'utilisation' }
  },
  {
    path: '/accessibility-statement',
    name: 'accessibility',
    component: AccessibilityPage,
    meta: { title: 'Accessibilité' }
  }
];
